<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <AppHeader />

    <!-- begin::Body -->
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
      <LeftMenu />

      <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <div class="m-content">
          <!--begin::Portlet-->
          <div class="m-portlet m-portlet--space">
            <div class="m-portlet__body">
              <div class="row">
                <div class="col-xl-3">
                  <div
                    class="m-tabs"
                    data-tabs="true"
                    data-tabs-contents="#m_sections"
                  >
                    <ul
                      id="m_nav"
                      class="m-nav m-nav--active-bg m-nav--active-bg-padding-lg m-nav--font-lg m-nav--font-bold m--margin-bottom-20 m--margin-top-10 m--margin-right-40"
                      role="tablist"
                    >
                      <li
                        v-for="(elem, index) in FAQItems"
                        :key="elem[index]"
                        class="m-nav__item"
                      >
                        <a
                          :class="{'m-nav__link m-tabs__item':true, 'm-tabs__item--active': index===0 }"
                          href="javascript:"
                          :data-tab-target="'#section_'+elem.id"
                        >
                          <span class="m-nav__link-text">{{ elem.title }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-xl-9">
                  <div
                    id="m_sections"
                    class="m-tabs-content"
                  >
                    <div
                      v-for="(elem, index) in FAQItems"
                      :id="'section_'+elem.id"
                      :key="elem[index]"
                      :class="{'m-tabs-content__item':true, 'm-tabs-content__item--active': index===0 }"
                    >
                      <h4 class="m--font-bold m--margin-top-15 m--margin-bottom-20">
                        {{ elem.title }} FAQ
                      </h4>
                      <div
                        :id="'section_'+elem.id+'_content'"
                        class="m-accordion  m-accordion--section m-accordion--padding-lg"
                      >
                        <div
                          v-for="(faqitem, indexb) in elem.items"
                          :key="indexb"
                          class="m-accordion__item"
                        >
                          <div
                            :id="'section_'+elem.id+'_content_'+indexb+'_head'"
                            class="m-accordion__item-head collapsed"
                            role="tab"
                            data-toggle="collapse"
                            :href="'#section_'+elem.id+'_content_'+indexb+'_body'"
                            aria-expanded="false"
                          >
                            <span class="m-accordion__item-title">{{ faqitem.question }}</span>
                            <span class="m-accordion__item-mode" />
                          </div>

                          <div
                            :id="'section_'+elem.id+'_content_'+indexb+'_body'"
                            class="m-accordion__item-body collapse"
                            role="tabpanel"
                            aria-labelledby="section_properties_content_1_head"
                            :data-parent="'#section_'+elem.id+'_content'"
                          >
                            <div class="m-accordion__item-content">
                              <p>
                                {{ faqitem.answer }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--end::Portlet-->
        </div>
      </div>
    </div>
    <!-- end:: Body -->

    <!-- BEGIN: Footer -->
    <AppFooter />
    <!-- END: Footer -->
  </div>
</template>

<script>

import AppHeader from '../common/Header.vue';
import AppFooter from '../common/Footer.vue';
import LeftMenu from '../common/menus/LeftMenu.vue';

export default {
    components: {
        AppFooter,
        AppHeader,
        LeftMenu,
    },
    data() {
        return {
            FAQItems: [
                {
                    'title': this.$t( 'Property.title' ),
                    'id': 'properties',
                    'items': [
                        {
                            'question': this.$t( 'FAQ.WhatShouldIUseForAReferenceNumber?' ),
                            'answer': this.$t( 'FAQ.WhatShouldIUseForAReferenceNumber?' ) + ' answer here',
                        },
                        {
                            'question': 'How do I add/delete/modify a property?',
                            'answer': 'How do I add/delete/modify a property?' + ' answer here',
                        },
                        {
                            'question': 'How do I see/print my invoice(s)?',
                            'answer': 'How do I see/print my invoice(s)?' + ' answer here',
                        },
                        {
                            'question': 'How to I export my properties from TS?',
                            'answer': 'How to I export my properties from TS?' + ' answer here',
                        },
                        {
                            'question': 'How do I add/delete a property? (Manual Service)',
                            'answer': 'How do I add/delete a property? (Manual Service)' + ' answer here',
                        },
                        {
                            'question': 'How do I add/delete a property? (XML Service)',
                            'answer': 'How do I add/delete a property? (XML Service)' + ' answer here',
                        },
                        {
                            'question': 'How can I feature my property?',
                            'answer': 'How can I feature my property?' + ' answer here',
                        },
                        {
                            'question': 'How do I change the details of a property?',
                            'answer': 'How do I change the details of a property?' + ' answer here',
                        },
                    ],
                },
                {
                    'title': this.$t( 'advertise.Directories' ),
                    'id': 'directories',
                    'items': [
                        {
                            'question': 'What should I use for a reference number?',
                            'answer': 'What should I use for a reference number?' + ' answer here',
                        },
                        {
                            'question': 'How do I add/delete/modify a property?',
                            'answer': 'How do I add/delete/modify a property?' + ' answer here',
                        },
                        {
                            'question': 'How do I see/print my invoice(s)?',
                            'answer': 'How do I see/print my invoice(s)?' + ' answer here',
                        },
                        {
                            'question': 'How to I export my properties from TS?',
                            'answer': 'How to I export my properties from TS?' + ' answer here',
                        },
                        {
                            'question': 'How do I add/delete a property? (Manual Service)',
                            'answer': 'How do I add/delete a property? (Manual Service)' + ' answer here',
                        },
                        {
                            'question': 'How do I add/delete a property? (XML Service)',
                            'answer': 'How do I add/delete a property? (XML Service)' + ' answer here',
                        },
                        {
                            'question': 'How can I feature my property?',
                            'answer': 'How can I feature my property?' + ' answer here',
                        },
                        {
                            'question': 'How do I change the details of a property?',
                            'answer': 'How do I change the details of a property?' + ' answer here',
                        },
                    ],
                },
                {
                    'title': this.$t( 'homepage.stats.Enquiries' ),
                    'id': 'enquiries',
                    'items': [
                        {
                            'question': 'Enquiries How to I export my properties from TS?',
                            'answer': 'Enquiries How to I export my properties from TS?' + ' answer here',
                        },
                        {
                            'question': 'Enquiries How do I add/delete a property? (Manual Service)',
                            'answer': 'Enquiries How do I add/delete a property? (Manual Service)' + ' answer here',
                        },
                        {
                            'question': 'Enquiries How do I add/delete a property? (XML Service)',
                            'answer': 'Enquiries How do I add/delete a property? (XML Service)' + ' answer here',
                        },
                        {
                            'question': 'Enquiries How can I feature my property?',
                            'answer': 'Enquiries How can I feature my property?' + ' answer here',
                        },
                        {
                            'question': 'Enquiries How do I change the details of a property?',
                            'answer': 'Enquiries How do I change the details of a property?' + ' answer here',
                        },
                    ],
                },
                {
                    'title': this.$t( 'Dashboard.services' ),
                    'id': 'services',
                    'items': [
                        {
                            'question': 'How can I cancel my service?',
                            'answer': 'How can I cancel my service?' + ' answer here',
                        },
                    ],
                },
            ],
        };
    },
};
</script>
